<section class="page-back">
  <!-- start banner Area -->
  <section class="top-banner">
    <div class="top-banner-img" style="">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 style="padding: 30px 0px 0px 0px !important;"> Informations de : <br>{{ candidate.getFirstName() }}
              {{ candidate.getLastName() }}
            </h1>
            <p class="text-white link-nav"><a [routerLink]="backURL" style="color: #ff5a00 !important">Candidatures</a>
              <span class="lnr lnr-arrow-right"></span>
              <span> Information candidat</span>
            </p>

          </div>
        </div>
      </div>
    </div>
  </section>
  <br><br>

  <!-- End banner Area -->

  <!-- cv thèque -->
  <section class="mb-4">
    <div class="row justify-content-center">
      <div class="col-md-11 ">
        <div class="card">
          <div class="card-body" style="padding: 20px 80px;">
            <div class="">
              <!-- <h2 class="mb-3" style="text-align: center;">CV Thèque</h2> -->
              <div class="row">
                <div class="col-md-6">
                  <fieldset class="form-area fieldset-panel mb-2">
                    <legend class="legend-style" style="width: 70%;"> Informations personnelles </legend>

                    <table class="table table-bordered">

                      <tr>
                        <td><span class="titre mr-5">Nom: </span></td>
                        <td>{{ candidate.getFirstName() }}</td>
                      </tr>
                      <tr>
                        <td><span class="titre mr-5">Prénoms: </span></td>
                        <td>{{ candidate.getLastName() }}</td>
                      </tr>
                      <tr>
                        <td><span class="titre mr-5">Sexe: </span></td>
                        <td>{{ candidate.getGender() }}</td>
                      </tr>
                      <tr>
                        <td><span class="titre mr-5">Nationalité: </span></td>
                        <td>{{ candidate.getCountry() }}</td>
                      </tr>
                      <tr>
                        <td><span class="titre mr-5">Date et lieu de naissance: </span></td>
                        <td>{{ candidate.getDateBirth() }}</td>
                      </tr>
                      <tr>
                        <td><span class="titre mr-5">Situation matrimoniale: </span></td>
                        <td>{{ candidate.getMaritalStatus() }}</td>
                      </tr>
                      <tr>
                        <td><span class="titre mr-5">Tél: </span></td>
                        <td>{{ candidate.getPhone1() }}</td>
                      </tr>
                      <tr>
                        <td><span class="titre mr-5"> E-mail:</span></td>
                        <td>{{ candidate.getEmail() }}</td>
                      </tr>
                    </table>

                  </fieldset>
                </div>
                <div class="col-md-6">
                  <fieldset class="form-area fieldset-panel mb-2">
                    <legend class="legend-style" style="width: 70%;"> Formations qualifiantes </legend>

                    <table class="table table-bordered">
                      <tr>
                        <th>Titre du certificat</th>
                        <th>Certificat</th>
                      </tr>
                      <tr *ngFor="let candidateCertificate of candidate.getCandidatesCertificates()">
                        <td>{{ candidateCertificate['libelle'] }}</td>
                        <td>

                          <a *ngIf="candidateCertificate['filePath'] != ''"
                            [href]="formatFilePath(candidateCertificate['filePath'])" target="_blank"
                            class="btn btn-primary a-btn-slide-text mr-1"><svg xmlns="http://www.w3.org/2000/svg"
                              width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                              <path
                                d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                              <path
                                d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                            </svg>
                          </a>

                        </td>
                      </tr>
                    </table>

                  </fieldset>
                </div>

              </div>
              <div>
                <fieldset class="form-area fieldset-panel mb-2">
                  <legend class="legend-style" style="width: 35%;"> Formations diplomantes </legend>

                  <table class="table table-bordered">
                    <tr>
                      <th>Formation</th>
                      <th>Université</th>
                      <th>Periode</th>
                      <th>Niveau d'étude</th>
                      <th>Diplôme</th>
                    </tr>
                    <tr *ngFor="let candidateTraining of candidate.getCandidatesTrainings()">
                      <td>{{ candidateTraining['trainings']['libelle'] }}</td>
                      <td>{{ candidateTraining['university'] }}</td>
                      <td>{{ candidateTraining['period_start'] }} à <span *ngIf="candidateTraining['in_progress']">ce
                          jour</span><span *ngIf="!candidateTraining['in_progress']">{{
                          candidateTraining['period_end']
                          }}</span></td>
                      <td>{{ candidateTraining['level_of_study'] }}</td>
                      <td>
                        <a *ngIf="candidateTraining['diploma_path'] != ''"
                          [href]="formatFilePath(candidateTraining['diploma_path'])" target="_blank"
                          class="btn btn-primary a-btn-slide-text mr-1"><svg xmlns="http://www.w3.org/2000/svg"
                            width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                            <path
                              d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                            <path
                              d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                          </svg>
                        </a>


                      </td>
                    </tr>
                  </table>
                </fieldset>
              </div>
              <div>
                <fieldset class="form-area fieldset-panel mb-2">
                  <legend class="legend-style" style="width: 40%;"> Expériences profssionnelles </legend>

                  <table class="table table-bordered">
                    <tr>
                      <th>Titre du poste</th>
                      <th>Société</th>
                      <th>Niveau de poste</th>
                      <th>Période</th>
                      <th>Manag. equipe</th>
                      <th>Titre sup. N + 1</th>
                      <th>Motif de départ</th>
                      <th>Attest./Certif.</th>
                    </tr>
                    <tr *ngFor="let experience of candidate.getCandidatesExperiences()">
                      <td>{{ experience['job_title'] }}</td>
                      <td>{{ experience['company'] }}</td>
                      <td>{{ experience['position_level'] }}</td>
                      <td>{{ experience['period_start'] }} à <span *ngIf="experience['in_progress']">ce jour</span><span
                          *ngIf="!experience['in_progress']">{{ experience['period_end'] }}</span></td>
                      <td>{{ experience['team_management'] }}</td>
                      <td>{{ experience['supervisor_title'] }}</td>
                      <td>{{ experience['reason_for_leaving'] }}</td>
                      <td>
                        <a *ngIf="experience['certificate_path'] != ''"
                          [href]="formatFilePath(experience['certificate_path'])" target="_blank"
                          class="btn btn-primary a-btn-slide-text mr-1"><svg xmlns="http://www.w3.org/2000/svg"
                            width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                            <path
                              d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                            <path
                              d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                          </svg>
                        </a>

                      </td>
                    </tr>
                  </table>

                </fieldset>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <fieldset class="form-area fieldset-panel mb-2">
                    <legend class="legend-style" style="width: 75%;"> Connaissances informatiques </legend>

                    <table class="table table-bordered">
                      <tr>
                        <th>Compétence</th>
                        <th>Niveau de maitrise</th>
                        <th>Niveau de maitrise</th>
                      </tr>
                      <tr *ngFor="let candidateSkill of candidate.getCandidatesSkills()">
                        <td>{{ candidateSkill['skills']['libelle'] }}</td>
                        <td>{{ candidateSkill['level'] }}</td>
                        <td>{{ candidateSkill['level'] }}</td>
                      </tr>
                    </table>

                  </fieldset>
                </div>
                <div class="col-md-6">
                  <fieldset class="form-area fieldset-panel mb-2">
                    <legend class="legend-style" style="width: 75%;"> Connaissances lingustique </legend>

                    <table class="table table-bordered">
                      <tr>
                        <th>Langue</th>
                        <th>Niveau de maitrise</th>
                        <th>Niveau de maitrise</th>
                      </tr>
                      <tr *ngFor="let candidateLanguage of candidate.getCandidatesLanguages()">
                        <td>{{ candidateLanguage['languages']['libelle'] }}</td>
                        <td>{{ candidateLanguage['level'] }}</td>
                        <td>{{ candidateLanguage['level'] }}</td>
                      </tr>
                    </table>

                  </fieldset>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </section>


</section>
<!-- End service Area -->